// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DyFW","input":"styles_input__2xe1J"};